export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del paso"])},
          "exec_attrs_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atributos del paso"])},
          "new_exec_attr_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrar atributos"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de que desea eliminar este paso?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "formalized_producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor formalizado"])},
          "formalized_crop_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo formalizado"])},
          "new_quality_inspect_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrar inspección de calidad"])},
          "show_quality_inspects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver inspecciones de calidad"])}
        }
      }
    }
  })
}